module.exports = __webpack_public_path__ + "static/img/title.9a16681.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/mobile_img/media5/title.png
// module id = osks
// module chunks = 7